<template>
<div>
<ob-modal2 style="overflow: scroll;" :show.sync="show" :type="1" width="900px" :backdrop="false">
    <div class="modal-header">
        <h4 class="modal-title">Initiate I-983</h4>
    </div>
    <div class="modal-body" style="padding-bottom: 0;">
        <div class="row">
            <div class="col-md-12">
                <label> Select form I-983 status</label>
                <div class="row rowgap">
                    <div class="col-md-4">
                        <div class="form-group">
                        <div class="radio-inline" style="padding-left: 0;">
                            <ob-radio name="I983Type"  :val="0" v-model="I983Type">Primary I-983</ob-radio>
                        </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <div class="radio-inline">
                            <ob-radio name="I983Type" :val="1" v-model="I983Type">Material Change</ob-radio>
                        </div>
                        </div>
                    </div>
                    <div class="col-md-4 ">
                        <div class="form-group">
                        <div class="radio-inline">
                            <ob-radio name="I983Type" :val="2" v-model="I983Type">Student Evaluation</ob-radio>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <component ref="dynamicComponent" :openModal.sync="show" :is="selectedComponent" :previousData="previousData" @initiated="$emit('initiated')" @onShowEmailSuccessPopup="onShowEmailSuccessPopup"></component>
    </div>
</ob-modal2>
<ob-modal2 :show.sync="ShowEmailSuccessPopup" :type="1">
    <div style="padding:30px 15px;text-align:center">
        <img style="width:45px;padding-bottom:10px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/success.png`" />
        <h3>An Email has been sent to the student</h3>
        <p>Student Information(Section-1 & 2) and Training Plan(Section-5) has been shared with </p>
        <p>{{StudentName}}</p>
    </div>
    <div style="padding: 0px 20px 20px 20px;text-align:center;">
        <ob-button @click="ShowEmailSuccessPopup = false;$emit('initiated');">Done</ob-button>
    </div>
</ob-modal2>
</div>
</template>
<script>
import InitiateI983Popup from './InitiateFlow/InitiateI983Popup.vue';
import InitiateMaterialChangePopup from './InitiateFlow/InitiateMaterialChangePopup.vue';
import InitiateStudentEvaluation from './InitiateFlow/InitiateStudentEvalution.vue';
export default {
    props: ["openModal"],
    data() {
        return {
            I983Type: 0,
            show: false,
            ShowEmailSuccessPopup: false,
            StudentName: ''
        }
    },
    components: {
        'initiate-i983-popup' : InitiateI983Popup,
        'initiate-material-change-popup' : InitiateMaterialChangePopup,
        'initiate-student-evaluation' : InitiateStudentEvaluation
    },
    computed: {
        selectedComponent() {
            if(this.I983Type == 1) {
                return 'initiate-material-change-popup';
            } else if(this.I983Type == 2) {
                return 'initiate-student-evaluation';
            } else { // Default
                return 'initiate-i983-popup';
            }
        },
        EmployeeId() {
            return this.$parent.EmployeeId;
        },
        StudentName() {
            return this.$parent.StudentName;
        },
        IsFinalEvaluationDone() {
            return this.$parent.IsFinalEvaluationDone;
        },
        previousData() {
            return {
                StudentName: this.$parent.$parent.StudentName,
                StudentEmail: this.$parent.$parent.StudentEmail,
                EmploymentStartDate: this.$parent.$parent.EmploymentStartDate
            }
        }
    },
    watch: {
        openModal(val) {
            this.show = val;

            if(val === true) { // On Modal Open
                this.I983Type = 0;
                this.$refs.dynamicComponent.copyFromStore();
            }
        },
        show(val) {
            this.$emit('update:openModal', val);
        },
    },
    created() {
        this.show = this.openModal;
    },
    methods: {
        onShowEmailSuccessPopup(name) {
            this.StudentName = name;
            this.show = false;
            this.ShowEmailSuccessPopup = true;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/InitiateI983Popup.vue